import { render } from "./Pos.vue?vue&type=template&id=065b1847&ts=true"
import script from "./Pos.vue?vue&type=script&lang=ts"
export * from "./Pos.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__